module.exports = __webpack_public_path__ + "img/turnon.7d5ebbc6.svg";